import { InstalledIntegrationType } from "@/types/installedintegration";

export interface IntegrationReconnectConfig {
  displayName: string;
}

// Integrations the global reconnect banner surfaces. Add new entries here as
// additional integrations adopt the InstalledIntegrationStatus.NEEDS_RECONNECT
// signal; the banner consumes this map directly, no banner-side branching.
export const SUPPORTED_RECONNECT_INTEGRATIONS: Partial<
  Record<InstalledIntegrationType, IntegrationReconnectConfig>
> = {
  [InstalledIntegrationType.PARAGON_GOOGLE]: { displayName: "Google email" },
  [InstalledIntegrationType.PARAGON_MICROSOFT]: {
    displayName: "Microsoft email",
  },
  [InstalledIntegrationType.PARAGON_EQUISOFT]: { displayName: "Equisoft" },
  [InstalledIntegrationType.GOOGLECALENDAR]: {
    displayName: "Google calendar",
  },
  [InstalledIntegrationType.MICROSOFTCALENDAR]: {
    displayName: "Outlook calendar",
  },
};

export type SupportedReconnectIntegrationType =
  keyof typeof SUPPORTED_RECONNECT_INTEGRATIONS;
